/* PURESHEEN — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Texto partido en palabras ---------- */
  function initSplit(root) {
    root.querySelectorAll('[data-sn-split]:not([data-split-done])').forEach(function (el) {
      el.setAttribute('data-split-done', '');
      var i = 0;
      (function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (part) {
              if (!part) return;
              if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
              var w = document.createElement('span'); w.className = 'sn-w';
              var inner = document.createElement('span'); inner.textContent = part;
              inner.style.setProperty('--i', i++);
              w.appendChild(inner); frag.appendChild(w);
            });
            child.parentNode.replaceChild(frag, child);
          } else if (child.nodeType === 1) { walk(child); }
        });
      })(el);
      el.classList.add('sn-split');
    });
  }

  /* ---------- Reveals con un único observer ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }) : null;

  function initReveal(root) {
    root.querySelectorAll('.sn-reveal, .sn-reveal-img, .sn-split, .sn-steps__line').forEach(function (el) {
      if (!io || reduce) { el.classList.add('is-in'); return; }
      io.observe(el);
    });
  }

  /* ---------- Parallax suave ---------- */
  var plx = [];
  function initParallax(root) {
    root.querySelectorAll('[data-sn-parallax]').forEach(function (el) {
      if (plx.indexOf(el) === -1) plx.push(el);
    });
  }
  function tickParallax() {
    if (reduce) return;
    var vh = window.innerHeight;
    plx.forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var k = parseFloat(el.getAttribute('data-sn-parallax')) || 0;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.transform = 'translate3d(0,' + (p * k * -100).toFixed(2) + 'px,0)';
    });
  }
  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { tickParallax(); ticking = false; });
  }, { passive: true });

  /* ---------- Historia sticky ---------- */
  function initStory(root) {
    root.querySelectorAll('[data-sn-story]').forEach(function (sec) {
      if (sec._sn) return; sec._sn = true;
      var steps = sec.querySelectorAll('.sn-story__step');
      var imgs = sec.querySelectorAll('.sn-story__img');
      var bar = sec.querySelector('.sn-story__progress');
      var counter = sec.querySelector('.sn-story__counter b');
      function set(i) {
        steps.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
        imgs.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
        if (bar) bar.style.setProperty('--p', (i + 1) / steps.length);
        if (counter) counter.textContent = String(i + 1).padStart(2, '0');
      }
      set(0);
      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) set(Array.prototype.indexOf.call(steps, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { obs.observe(s); });
    });
  }

  /* ---------- Comparador antes / después ---------- */
  function initCompare(root) {
    root.querySelectorAll('[data-sn-compare]').forEach(function (stage) {
      if (stage._sn) return; stage._sn = true;
      var range = stage.querySelector('input[type=range]');
      function set(v) { stage.style.setProperty('--pos', v + '%'); }
      set(range.value);
      range.addEventListener('input', function () { stage._touched = true; set(range.value); });
      if (reduce || !('IntersectionObserver' in window)) return;
      var start = parseFloat(range.value);
      var o = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting) return; o.disconnect();
        var t0 = null, dur = 2600;
        function step(t) {
          if (stage._touched) return;
          if (!t0) t0 = t;
          var k = Math.min((t - t0) / dur, 1);
          var v = start + Math.sin(k * Math.PI * 2) * 22 * (1 - k);
          set(v); range.value = v;
          if (k < 1) requestAnimationFrame(step);
        }
        setTimeout(function () { requestAnimationFrame(step); }, 500);
      }, { threshold: 0.5 });
      o.observe(stage);
    });
  }

  /* ---------- Selector de colores ---------- */
  function initColors(root) {
    root.querySelectorAll('[data-sn-colors]').forEach(function (sec) {
      if (sec._sn) return; sec._sn = true;
      var sw = sec.querySelectorAll('.sn-swatch');
      var imgs = sec.querySelectorAll('.sn-colors__img');
      var name = sec.querySelector('.sn-colors__name');
      var btn = sec.querySelector('[data-sn-colors-link]');
      var label = btn ? btn.querySelector('[data-label]') : null;
      var idx = 0, timer = null;
      var auto = parseInt(sec.getAttribute('data-auto'), 10) || 0;
      function set(i) {
        idx = i;
        sw.forEach(function (s, j) { s.classList.toggle('is-active', i === j); s.setAttribute('aria-pressed', i === j); });
        imgs.forEach(function (s, j) { s.classList.toggle('is-active', i === j); });
        if (name) name.textContent = sw[i].getAttribute('data-name');
        if (btn && sw[i].getAttribute('data-url')) btn.href = sw[i].getAttribute('data-url');
        if (label) label.textContent = label.getAttribute('data-label').replace('[color]', sw[i].getAttribute('data-name'));
      }
      sw.forEach(function (s, j) {
        s.addEventListener('click', function () { clearInterval(timer); set(j); });
      });
      set(0);
      if (auto > 0 && !reduce) timer = setInterval(function () { set((idx + 1) % sw.length); }, auto * 1000);
    });
  }

  /* ---------- FAQ / acordeones ---------- */
  function initAccordions(root) {
    root.querySelectorAll('.sn-faq__q:not([data-done])').forEach(function (q) {
      q.setAttribute('data-done', '');
      q.addEventListener('click', function () {
        var item = q.closest('.sn-faq__item');
        var open = !item.classList.contains('is-open');
        var group = q.closest('[data-sn-single]');
        if (group && open) group.querySelectorAll('.sn-faq__item.is-open').forEach(function (o) {
          o.classList.remove('is-open'); o.querySelector('.sn-faq__q').setAttribute('aria-expanded', 'false');
        });
        item.classList.toggle('is-open', open);
        q.setAttribute('aria-expanded', open);
      });
    });
  }

  /* ---------- Cuenta atrás ---------- */
  function initCountdown(root) {
    root.querySelectorAll('[data-sn-countdown]').forEach(function (el) {
      if (el._sn) return; el._sn = true;
      var end = new Date(el.getAttribute('data-sn-countdown')).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      var u = el.querySelectorAll('b');
      function tick() {
        var d = end - Date.now();
        if (d <= 0) { el.hidden = true; clearInterval(t); return; }
        var v = [Math.floor(d / 864e5), Math.floor(d / 36e5) % 24, Math.floor(d / 6e4) % 60, Math.floor(d / 1e3) % 60];
        v.forEach(function (x, i) { if (u[i]) u[i].textContent = String(x).padStart(2, '0'); });
      }
      var t = setInterval(tick, 1000); tick();
    });
  }

  /* ---------- Página de producto ---------- */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    var n = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
  }

  function initProduct(root) {
    root.querySelectorAll('[data-sn-pdp]').forEach(function (pdp) {
      if (pdp._sn) return; pdp._sn = true;
      var data = JSON.parse(pdp.querySelector('[data-sn-variants]').textContent);
      var fmt = pdp.getAttribute('data-money');
      var form = pdp.querySelector('form[action*="/cart/add"]');
      var idInput = form.querySelector('input[name=id]');
      var slides = pdp.querySelectorAll('.sn-gallery__slide');
      var thumbs = pdp.querySelectorAll('.sn-gallery__thumb');
      var cur = 0;
      slides.forEach(function (s, j) { if (s.classList.contains('is-active')) cur = j; });

      // Las fotos que no se ven llegan sin src: se cargan al llegar a ellas (y la siguiente/anterior)
      function load(j) {
        var s = slides[(j + slides.length) % slides.length];
        var img = s && s.querySelector('img[data-src]');
        if (!img) return;
        img.loading = 'eager';
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        img.removeAttribute('data-src'); img.removeAttribute('data-srcset');
      }
      if (slides.length) window.addEventListener('load', function () { setTimeout(function () { load(cur + 1); }, 1500); });

      function go(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        load(cur); load(cur + 1); load(cur - 1);
        slides.forEach(function (s, j) { s.classList.toggle('is-active', j === cur); });
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === cur); });
        if (thumbs[cur]) thumbs[cur].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
      thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
      var prev = pdp.querySelector('[data-prev]'), next = pdp.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { go(cur - 1); });
      if (next) next.addEventListener('click', function () { go(cur + 1); });
      var main = pdp.querySelector('.sn-gallery__main'), x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); x0 = null;
        });
      }

      function selected() {
        var vals = [];
        pdp.querySelectorAll('[data-sn-option]').forEach(function (g) {
          var a = g.querySelector('.is-active'); vals.push(a ? a.getAttribute('data-value') : null);
        });
        return vals;
      }
      function update(fromUser) {
        var vals = selected();
        var v = data.find(function (x) { return x.options.every(function (o, i) { return vals[i] === null || o === vals[i]; }); });
        if (!v) return;
        idInput.value = v.id;
        pdp.querySelectorAll('[data-sn-price]').forEach(function (el) { el.textContent = money(v.price, fmt); });
        pdp.querySelectorAll('[data-sn-compare-price]').forEach(function (el) {
          el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price, fmt) : '';
        });
        pdp.querySelectorAll('[data-sn-selected]').forEach(function (el) {
          var i = parseInt(el.getAttribute('data-sn-selected'), 10); el.textContent = vals[i] || '';
        });
        document.querySelectorAll('[data-sn-add]').forEach(function (b) {
          b.disabled = !v.available;
          var l = b.querySelector('[data-label]');
          if (l) l.textContent = v.available ? b.getAttribute('data-add') : b.getAttribute('data-soldout');
        });
        if (fromUser && v.featured_media) {
          slides.forEach(function (s, j) { if (s.getAttribute('data-media') == v.featured_media) go(j); });
        }
        if (fromUser && window.history.replaceState) {
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        var stImg = document.querySelector('.sn-sticky img');
        if (stImg && v.image) stImg.src = v.image;
      }
      pdp.querySelectorAll('[data-sn-option]').forEach(function (g) {
        g.querySelectorAll('[data-value]').forEach(function (b) {
          b.addEventListener('click', function () {
            g.querySelectorAll('[data-value]').forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-pressed', 'false'); });
            b.classList.add('is-active'); b.setAttribute('aria-pressed', 'true');
            update(true);
          });
        });
      });
      update(false);

      var qty = pdp.querySelector('.sn-qty input');
      pdp.querySelectorAll('[data-qty]').forEach(function (b) {
        b.addEventListener('click', function () {
          qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
        });
      });

      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var btns = document.querySelectorAll('[data-sn-add]');
        btns.forEach(function (b) { b.disabled = true; });
        var fd = new FormData(form);
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' }
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            btns.forEach(function (b) { b.disabled = false; });
            if (!res.ok) { alert(res.j.description || res.j.message || 'Error'); return; }
            showToast(res.j);
            refreshBubble();
          }).catch(function () { form.submit(); });
      });

      // Barra fija de compra
      document.querySelectorAll('[data-sn-sticky-add]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      });
      var sticky = document.querySelector('.sn-sticky');
      var anchor = pdp.querySelector('.sn-pdp__buy');
      if (sticky && anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(anchor);
      }
    });
  }

  function refreshBubble() {
    fetch(window.location.pathname + '?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var b = document.getElementById('cart-icon-bubble');
      if (b && s['cart-icon-bubble']) {
        var tmp = document.createElement('div'); tmp.innerHTML = s['cart-icon-bubble'];
        var inner = tmp.querySelector('.shopify-section') || tmp;
        b.innerHTML = inner.innerHTML;
      }
    }).catch(function () {});
  }

  function showToast(item) {
    var t = document.querySelector('.sn-toast');
    if (!t) return;
    var img = t.querySelector('img');
    if (img && item.image) img.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    var b = t.querySelector('b'); if (b) b.textContent = item.product_title;
    var s = t.querySelector('[data-variant]'); if (s) s.textContent = item.variant_title || '';
    t.classList.add('is-on');
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-on'); }, 6000);
  }

  function initAll(root) {
    root = root || document;
    initSplit(root); initReveal(root); initParallax(root); initStory(root); initCompare(root);
    initColors(root); initAccordions(root); initCountdown(root); initProduct(root);
    tickParallax();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  // Editor de Shopify: re-inicializar al cambiar secciones
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
